import { render, staticRenderFns } from "./ProductItem2.vue?vue&type=template&id=12af8ff4&scoped=true"
import script from "./ProductItem2.vue?vue&type=script&lang=js"
export * from "./ProductItem2.vue?vue&type=script&lang=js"
import style0 from "./ProductItem2.vue?vue&type=style&index=0&id=12af8ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af8ff4",
  null
  
)

export default component.exports